<template>
  <div class="distributor-header" :style="setCssVar">
    <!--头部广告位banner-->
    <div v-if="topAdvertisingImg && !isAlibabaDistributor"
      class="top_banner_style" @click="toClearanceList">
      <img :src="topAdvertisingImg" alt="">
    </div>
    <!--头部导航菜单区域-->
    <headTop></headTop>
    <div class="header-conter">
      <!--logo和搜索框区域-->
      <div class="search-box">
        <div class="logo-box">
          <img v-if="isAlibabaDistributor" :src="tongToolUrl" style="vertical-align: middle" width="240" height="21">
          <img v-else :src="logoUrl" style="cursor: pointer; vertical-align: middle;" width="210" height="22" @click="toShoping" :alt="$t('key1000009')">
        </div>
        <div class="search-center">
          <input v-model.trim="searchValue" class="search-input" :placeholder="$t('key1000010')" @keyup.enter="searchBtn"/>
          <button class="search-btn" @click="searchBtn">{{ $t('key1000011') }}</button>
          <!--消息中心-->
          <news-box :openType="openType"></news-box>
        </div>
      </div>
      <!--所有分类区域-->
      <div class="classification-box" v-if="!isAlibabaDistributor">
        <div class="classification-title">
          <Icon type="md-menu" size="26" color="#FD5425" class="menu_icon_styles"/>
          <p class="title">{{ $t('key1000012') }}</p>
          <classification :menuList="menuList" @toListBtn="toListBtn"></classification>
        </div>
        <!--商品参与活动的tab栏-->
        <activityTab></activityTab>
      </div>
    </div>
  </div>
</template>

<script>
import classification from '@/components/layout/shopping/common/classification';
import api from '@/api/';
import newsBox from "@/components/common/newsBox";
import headTop from "@/components/layout/shopping/common/headTop";
import Mixin from '@/components/mixin/common_mixin';
import activityTab from "@/components/common/activityTab";
import {advertisingLinkAddress, pageJump, isAlibabaDistributor, commonSessionStorage, handleLogoUrl, getCloudTreeData} from "@/utils/common";

export default {
  mixins: [Mixin],
  data() {
    return {
      tongToolUrl: require('@/assets/images/tongTool.png'),
      menuList: [],
      searchValue: '',
      openType: '_self',
      jumpTargetObj: null,
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    topAdvertisingImg() {
      let mallAdvertising = commonSessionStorage.getItem('mallAdvertising');
      let advertisingList = this.$store.state.mallAdvertising.length > 0 ? this.$store.state.mallAdvertising : mallAdvertising;
      let imagePath = '';
      if (advertisingList && advertisingList.length > 0) {
        advertisingList.map((item) => {
          // 顶部广告位
          if (item.orientationType === 0) {
            if (item.status) {
              imagePath = item.ymsAdvertisementDetailBos[0].imagePath;
              this.jumpTargetObj = item.ymsAdvertisementDetailBos[0];
            }
          }
        });
      }
      return imagePath;
    },
    isAlibabaDistributor() {
      return isAlibabaDistributor();
    },
    setCssVar() {
      return {
        '--subject-color': this.isAlibabaDistributor ? '#2D8CF0' : '#FD5425'
      };
    },
    logoUrl() {
      return handleLogoUrl();
    }
  },
  created() {
    if (!isAlibabaDistributor()) {
      this.getClassificationData();
    }
  },
  methods: {
    // 获取所有分类的数据
    getClassificationData() {
      let v = this;
      v.menuList = [];
      getCloudTreeData(api.distributor_post_ymsProductCategory_shopping_queryForExistsProduct).then((data) => {
        v.menuList = data;
      });
    },
    // 选择分类菜单
    toListBtn(data) {
      if (data.ymsProductCategoryId && data.productCategoryCode) {
        let talg = window.location.href.split('//');
        let url = `/index.html#/shopList?ymsProductCategoryId=${data.ymsProductCategoryId}&productCategoryCode=${data.productCategoryCode}`;
        if (talg[1].includes('localhost')) {
          let link = `${talg[0]}//${window.location.host}${url}`;
          window.open(link, '_blank');
        } else {
          let link = `${talg[0]}//${window.location.host}/yms-shopping-service/${url}`;
          window.open(link, '_blank');
        }
      }
    },
    // 模糊搜索
    searchBtn() {
      if (this.searchValue) {
        let talg = window.location.href.split('//');
        let url = `/index.html#/shopList?searchValue=${this.searchValue}`;
        if (talg[1].includes('localhost')) {
          let link = `${talg[0]}//${window.location.host}${url}`;
          window.open(link, '_blank');
        } else {
          let link = `${talg[0]}//${window.location.host}/yms-shopping-service/${url}`;
          window.open(link, '_blank');
        }
      } else {
        return false;
      }
    },
    // 点击logo图片时，跳转到商城首页
    toShoping() {
      pageJump('/index.html#/index', '/yms-shopping-service', '_blank');
    },
    // 点击头部广告位的banner图
    toClearanceList() {
      let v = this;
      advertisingLinkAddress(v.jumpTargetObj);
    },
  },
  components: {
    classification,
    newsBox,
    headTop,
    activityTab
  }
};
</script>

<style>
.distributor-header .header-menu {
  width: 100% !important;
  padding: 0 25px;
}
</style>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.distributor-header {
  width: 100%;
  background: #FFFFFF;
  border-bottom: 2px solid var(--subject-color);

  .top_banner_style {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #FBDBE0;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  .nav-box {
    border-bottom: 1px solid #E7E8ED;

    .header-menu {
      padding: 0 24px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .right-box {
        width: 60%;
        display: flex;
        justify-content: flex-end;
      }

      .header-txt {
        cursor: pointer;
        display: inline-block;
        font-size: 12px;
        font-family: PingFang SC;
        color: #777777;
        display: flex;
        align-items: center;

        .user-icon {
          margin-right: 5px;
          font-weight: initial;
          color: #777777;
        }

        &:hover {
          color: var(--subject-color);

          .user-icon {
            color: var(--subject-color);
          }
        }
      }

      .line_item {
        color: #c3c1c1;
        margin: 0 10px;
      }
    }
  }

  .header-conter {
    padding: 0 24px;

    .logo-box {
      width: 152px;
      text-align: center;
    }

    .search-box {
      padding: 17px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .search-center {
        display: flex;
        align-items: center;
        font-family: PingFang SC;

        .search-input {
          width: 460px;
          flex: 1;
          height: 40px;
          line-height: 40px;
          color: #666;
          background: #EFF0F5;
          border-color: transparent !important;
          box-shadow: none !important;
          outline: none;
          border: none;
          padding: 0 10px;
          font-size: 14px;
        }

        .search-input::-webkit-input-placeholder {
          color: #AAAAAA;
        }

        .search-input:-moz-placeholder {
          color: #AAAAAA;
        }

        .search-input::-moz-placeholder {
          color: #AAAAAA;
        }

        .search-input:-ms-input-placeholder {
          color: #AAAAAA;
        }

        .search-btn {
          font-size: 14px;
          width: 80px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-weight: 400;
          color: #FFFFFF;
          background-color: var(--subject-color);
          border: none;
          outline: none;
          cursor: pointer;
        }
      }
    }

    .classification-box {
      display: flex;
      align-items: center;
      height: 42px;

      .classification-title {
        height: 42px;
        background: #ffffff;
        color: var(--subject-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        margin-right: 15px;
        position: relative;
        cursor: pointer;

        .title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          width: 155px;
          padding-left: 12px;
        }

        .menu_icon_styles {
          padding-left: 10px;
        }

        .menu-box {
          display: none;
          position: absolute;
          left: 0;
          top: 40px;
          z-index: 1000;

        }

        &:hover {
          background-color: var(--subject-color);
          color: #ffffff;

          .menu_icon_styles {
            color: #fff !important;
          }

          .menu-box {
            display: flex !important;
            box-shadow: 0 0 15px #787878;
          }
        }
      }
    }
  }
}

.lang-text {
  display: flex;
  width: 150px;
  line-height: 32px;
  color: #777777;
}

.languages .flag {
  height: 32px;
  width: 32px;
  margin-left: 5px;
  background: url('../../../assets/images/flags.png') no-repeat;
}

.languages .zh-CN {
  background-position: 0 -32px;
}

.languages .en-US {
  background-position: 0 0;
}
</style>
